var rich_content_viewer_default = {
  "fontElementMap": "VwlNb",
  "wrapper": "rGqAX",
  "pluginContainerMobile": "CcZg-",
  "viewer": "-RNAl",
  "android": "QMWR4",
  "rootedTraversedContent": "Ll6Z5",
  "atomic": "snGMD",
  "toolbar": "wjiqW",
  "block": "_4YuKG"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
